const SERVICE = "market";

const cart = async (api, params) =>
  api.setMethod().get().setService(SERVICE).process("/cart", params);

const ServiceCart = async (api, params) =>
  api.setMethod().get().setService(SERVICE).process(`/cart`, params);

const cartsCount = async (api) =>
  api.setMethod().get().setService(SERVICE).process("/cart/count");

const createCart = async (api, body) =>
  api.setMethod().post().setService(SERVICE).setBody(body).process("/cart");

const createServicesCart = async (api, mode, body) =>
  api
    .setMethod()
    .post()
    .setService(SERVICE)
    .setBody(body)
    .process(`/cart?mode=${mode}`);

const delCart = async (api, id) =>
  api.setMethod().delete().setService(SERVICE).process(`/cart/${id}`);

module.exports = {
  cart,
  cartsCount,
  createCart,
  delCart,
  createServicesCart,
  ServiceCart,
};
